import { useEffect, useRef } from 'react';
import useScroller from './use-scroller';

type ScrollAction = 'none' | 'scroll-down';

export default function useScrollEffect(
  id: string,
  value: string | number = null,
  successorOffset = 1,
  action: ScrollAction = 'scroll-down',
) {
  const scroller = useScroller();
  const { scrollToSuccessor, scrollToError } = scroller;
  const ref = useRef(value);

  useEffect(() => {
    // if previous value was not set but it is set now, we need to initiate scrolling
    const fire = ref.current === null && (!!value || value === 0);
    ref.current = value;

    if (fire && action === 'scroll-down') {
      setTimeout(() => scrollToSuccessor(id, successorOffset), 300);
    } else {
      setTimeout(() => scrollToError(), 300);
    }
  }, [
    id,
    action,
    value,
    scrollToSuccessor,
    successorOffset,
    scroller,
    scrollToError,
  ]);

  return scroller;
}
